import { DATA_API_SERVICE } from "@/appConfig";
import { AuditLogItem } from "@/classes/audit";
import sortBy from "lodash/sortBy";
import API from "@/api/api";

export type AuditLogItemResponse = {
  action: string;
  entityType: string;
  entityId: string;
  createdBy: string;
  id: string;
  description: string;
  entityProperty: string;
  entityOrg: string;
  createdAt: string; // date
};

async function getAuditHistory() {
  try {
    const auditLogItemsResponse = await API.get<AuditLogItemResponse[]>(`${DATA_API_SERVICE}/audit`);
    return sortBy(
      auditLogItemsResponse.data.map(item => {
        return new AuditLogItem({
          ...item,
          createdAt: new Date(item.createdAt)
        });
      }),
      item => item.createdAt
    ).reverse();
  } catch (e) {
    return [];
  }
}

const APIAudit = {
  getAuditHistory
};

export default APIAudit;
